
import { useCallback, useEffect, useMemo, useState } from "react";
import { Roles, rolesColumns } from "./RolesColumns";
import { fetchRoles } from "@/apiCalls/apiCalls";
import Spinner from "../spinnner/Spinner";
import { DataTable } from "@/dataTables/data-table";
import { Button } from "@/components/ui/button";
import AddRolesDrawer from "./AddRolesDrawer";
import UpdateRolesDrawer from "./UpdateRoleDrawer";
import AddPermissionRoleDrawer from "./AddPermissionRoleDrawer";
import { jwtDecode } from "jwt-decode"
import useAuth from "@/hooks/useAuth";
import { RolesDataTables } from "./RolesDataTables";
import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "@/context/UseAxiosPrivate";
import { errorNotification } from "@/utils/Notification";

export default function RolesFn() {
    const [data, setData] = useState<Roles[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [showAddRolesDrawer, setShowAddRolesDrawer] = useState(false)
    const [showUpdateRolesDrawer, setShowUpdateRolesDrawer] = useState(false)
    const [showAddPermissionDrawer, setShowAddPermissionDrawer] = useState(false)
    const [rolesData, setRolesData] = useState<Roles | undefined>(undefined)
    const { auth } = useAuth()
    let token: any = auth.accessToken
    const decoded: any = jwtDecode(token);
    let roles: string[] = decoded.UserInfo.roles
    const navigate = useNavigate()
    const location = useLocation()
    const axiosPrivate = useAxiosPrivate()


    const getRoles = () => {
        setLoading(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/roles', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: Roles[]) => {
                if (isMounted) {
                    setData(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            }).finally(() => {
                setLoading(false)
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    useEffect(() => {
        getRoles()
    }, [])

    
    const editFunctionCall = (roles: Roles) => {
        setRolesData(roles)
        setShowUpdateRolesDrawer(!showUpdateRolesDrawer)
    }

    const addPermissionsFunctionCall = (roles: Roles) => {
        setRolesData(roles)
        setShowAddPermissionDrawer(!showAddPermissionDrawer)
    }



    const onEdit = useCallback(
        (roles: Roles) => editFunctionCall(roles),
        []
    )
    const onAddPermissions = useCallback(
        (roles: Roles) => addPermissionsFunctionCall(roles),
        []
    )


    const RolesColumnsData = useMemo(() => rolesColumns({ onEdit, onAddPermissions, roles }), [])

    if (loading) {
        return <Spinner />
    }


    return (
        <main className='mx-3 mt-16 sm:ml-[300px] sm:mt-3'>
            {roles.includes('role-create') && (<Button
                variant='default'
                className="flex items-center justify-end"
                onClick={() => setShowAddRolesDrawer(!showAddRolesDrawer)}
            >
                Create roles
            </Button>)}
            <RolesDataTables columns={RolesColumnsData} data={data} filterNameColumn="name" />
            <AddRolesDrawer
                showAddRolesDrawer={showAddRolesDrawer}
                setShowAddRolesDrawer={setShowAddRolesDrawer}
                getRoles={getRoles}
            />

            {rolesData && (
                <UpdateRolesDrawer
                    showUpdateRolesDrawer={showUpdateRolesDrawer}
                    setShowUpdateRolesDrawer={setShowUpdateRolesDrawer}
                    Roles={rolesData}
                    getRoles={getRoles}
                    setRolesData={setRolesData}
                />
            )}
            {rolesData && (
                <AddPermissionRoleDrawer
                    showAddPermissionDrawer={showAddPermissionDrawer}
                    setShowAddPermissionDrawer={setShowAddPermissionDrawer}
                    Roles={rolesData}
                    getRoles={getRoles}
                    roles={roles}
                    setRolesData={setRolesData}
                />
            )}
        </main>
    )
}